import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  Avatar,
  CircularProgress,
} from "@mui/material";
import DoneImage from "../../../Components/assets/Images/congratsdoneimage.svg";
import ErrorImage from "../../../Components/assets/Images/errorImage.svg";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "../../../pages/Styles/Redirect.module.scss";

// import { digiLockerAuthenticationAPICall } from "../shared/APICalls";

import { useDispatch, useSelector } from "react-redux";
import { SegmentUpdateFetchIncomeProofDataAPICall } from "../SegmentUpdateAPICalls";
import { REDIRECTURL } from "../../../shared/constants";
import jwt_decode from "jwt-decode";

export default function SegmentUploadIncomeFetchResponse() {
  const [countDown, setCountDown] = useState(3);
  const [displayError, setDisplayError] = useState(false);
  const [loading, setLoading] = useState(false);

  const pathName = useLocation().search;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());

  //  console.log("params", params[" request_id"]);
  const req = params.request_id;
  const state = params.state;

  const userObject: any = state ? jwt_decode(state) : {};
  // const state =
  // "finupdate_token=IozzhtWPF+h32CXybnyOecm4bByZDHBKQPXj8p1HfvctOSCxattm8wxDvhbqty/mAbrC5BzVEsHjz69+nDv6dcICa2zZf1dIFT7bwUOvzU43hBTrDt61vVDbJDyQDMl3h/cpAQ/OtELSHCFIoX65X8jCQDOQiDSUK+MNVQHHe8I=; userId=KC1593; deviceId=7468669e-4229-4e1f-adf7-954fb966e697";

  sessionStorage.setItem("access-token", state);

  function sendDetails() {
    let obj: any = {
      // consent_id: doc_id,
      request_id: userObject?.request_id,
      callback_url: "",
    };
    setLoading(true);
    SegmentUpdateFetchIncomeProofDataAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("res", responseData)
        setLoading(false);
        const redirectParams = new URLSearchParams(window.location.search);
        redirectParams.set("status", "success");
        navigate({ search: urlParams.toString() }, { replace: true });
        setTimeout(() => {
          window.location.href = `${REDIRECTURL}segmentUpdate/upload_documents?status=success`;
        }, 3000);
      })
      .catch((error: any) => {
        setLoading(false);
        setDisplayError(true);
        const redirectParams = new URLSearchParams(window.location.search);
        redirectParams.set("status", "failed");
        navigate({ search: urlParams.toString() }, { replace: true });
        setTimeout(() => {
          window.location.href = `${REDIRECTURL}segmentUpdate/upload_documents?status=failed`;
        }, 3000);
      });
  }

  //   useEffect(() => {
  //     sendDetails();
  //   }, []);

  useEffect(() => {
    if (window.location.href.includes("Cancelled")) {
      //  console.log("cancel");
      setDisplayError(true);
    } else {
      setDisplayError(false);
      sendDetails();
    }
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountDown((prevCountDown) => prevCountDown - 1);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (countDown < 0) {
      setCountDown(3);
    }
  }, [countDown]);

  return (
    <>
      <div className={styles.mainWrapperTop}>
        <div className={styles.wrapper}>
          <div className={styles.step}>
            {loading ? (
              <CircularProgress style={{ width: "80px", height: "80px" }} />
            ) : (
              <img src={!displayError ? DoneImage : ErrorImage} />
            )}
          </div>
          <div className={styles.leftContainer}>
            <div className={styles.headerSection}>
              <p className={styles.signup}>
                {" "}
                {loading
                  ? "Inprogress..."
                  : displayError
                    ? "Error fetching your Documents"
                    : "We have obtained your documents"}{" "}
              </p>
              <div className={styles.textdiv}>
                <p className={styles.instructiontext}>
                  {loading
                    ? "Please wait..., we are fetching your Documents. Please don't Close the Window."
                    : `You will be redirected in 3 seconds.`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
